import { ServiceHelper } from "src/app/core/helper/services.helper";
import { Utilities } from "src/app/core/helper/util";
import { Page, PageType } from "src/app/data/schema/cbs/page";

export class RoutingHelper {

    // All these routes would need to be updated when this class is copied to client, 
    // since the routes will be quite different
    static routeToPage(p: Page){
        RoutingHelper.routeTo(p.pgType, p.slug)
    }

    static routeTo(pageType: PageType, slug: string, entityId?: number ){

        // fall back to using id if no slug provided
        if ( Utilities.stringEmpty(slug) ) { slug = entityId + '';}
        
        switch(pageType) {
            case PageType.Event:
                ServiceHelper.navCtrl.navigateRoot('/events/' + slug); break;
            case PageType.EventCategory:
                ServiceHelper.navCtrl.navigateRoot('/events/events-home-page/382701/general'); break; 
            case PageType.Post:
                ServiceHelper.navCtrl.navigateRoot('/engagement/post/' + slug); break; 
          }
    }
}